<template>
  <AppOnOffToggle v-model="includeAccruals">{{ label }}</AppOnOffToggle>
</template>

<script>
export default {
  name: 'ReportIncludeAccrualsToggle',
  props: {
    label: { type: String, default: 'Include accruals' },
  },
  computed: {
    includeAccruals: {
      get() {
        return this.$store.getters.includeAccruals;
      },
      set(newValue) {
        this.$store.dispatch('updateSearch', { include_accruals: newValue });
      },
    },
  },
};
</script>
